import ReactDOM from "react-dom/client";

import ScrollDelay from "./src/components/shouldUpdateScroll";
import CustomLayout from "./src/components/wrapPageElement";
import "./src/styles/global.css";

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};

export const wrapPageElement = CustomLayout;
export const shouldUpdateScroll = ScrollDelay;
